<template>
  <full-width>
    <back-button />
    <centralized>
      <img
        src="@/assets/img/home-locate-vending-machines.png"
        class="h-32 mx-auto"
      />
      <h2
        class="flex justify-center text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
      >
        Locate Vending Machines
        <tooltip height="h-auto">
          <p data-e2e-attr="locate-vending-tooltip">Pre-order period: {{ preOrderPeriod }}</p>
          <p data-e2e-attr="locate-vending-tooltip">Collection period: {{ collectionPeriod }}</p>
          <p class="mt-2" data-e2e-attr="locate-vending-tooltip">
            For details on free mask collection eligibility, pre-order quota, and locations, click
            <a
              data-e2e-attr="locate-vending-tooltip"
              class="font-bold underline cursor-pointer"
              :href="cheatSheetUrl"
              target="_blank"
              >here</a
            >.
          </p>
          <p v-if="isPreOrderActive" class="mt-2" data-e2e-attr="locate-vm-page-pre-order-link">
            To purchase additional masks, select '<a
              class="font-bold underline cursor-pointer"
              @click="
                () => $router.push({ name: 'Purchase', query: $route.query })
              "
              >Pre-order</a
            >' in the menu.
          </p>
          <p class="mt-2" data-e2e-attr="locate-vending-tooltip">
            One free mask per government-issued ID. No refunds or exchanges after collection for hygiene reasons. Please choose the correct mask size (find out your mask size
            <a
              class="font-bold underline cursor-pointer"
              href="http://stayprepared.sg/sizing-guide"
              target="_blank"
              >here</a
            >).
          </p>
        </tooltip>
      </h2>
      <div class="grid max-w-lg gap-3 mx-auto mt-2">
        <div>
          <p
            class="max-w-2xl mx-auto text-base leading-7 text-center tmsk-blue-text"
          >
            Find the vending machine closest to you.
          </p>
          <div class="p-4 mt-4 rounded-md bg-blue-50">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg
                  class="w-5 h-5 text-blue-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="flex-1 ml-3 info-box md:flex md:justify-between">
                <p class="text-sm leading-5 text-blue-700" data-e2e-attr="locate-vending-collection-end-message">
                  Collection ends on {{collectionEndDate}}. Please check back for the latest updates.
                </p>
              </div>
            </div>
          </div>
          <h3
            class="flex justify-center mt-6 text-lg font-bold text-center tmsk-blue-text"
          >
            Enter Postal Code
          </h3>
          <div class="flex mt-2 rounded-md shadow-sm">
            <input
              class="block w-full px-6 py-2 m-auto border rounded-full outline-none tmsk-blue-border sm:text-sm sm:leading-5"
              placeholder="Enter postal code"
              v-model="input"
              @keyup.enter="handleSearch"
            />
          </div>
          <h3
            class="flex justify-center mt-6 text-lg font-bold text-center tmsk-blue-text"
          >
            Select Mask Type
          </h3>
          <!-- RADIO BUTTONS FOR FILTER -->
          <!-- To make api request on radio check -->
          <!-- <div class="mt-2 text-left">
            <label class="inline-flex items-center pb-1 ml-5">
              <input
                type="radio"
                class="form-radio"
                name="radio"
                value="all"
                v-model="selectedSku"
              />
              <span class="ml-2 tmsk-blue-text">All</span>
            </label>
            <label class="inline-flex items-center pb-1 ml-5">
              <input
                type="radio"
                class="form-radio"
                name="radio"
                value="sm2_adult_white"
                v-model="selectedSku"
              />
              <span class="ml-2 tmsk-blue-text">Adult White</span>
            </label>
            <label class="inline-flex items-center pb-1 ml-5">
              <input
                type="radio"
                class="form-radio"
                name="radio"
                value="sm2_kids_white"
                v-model="selectedSku"
              />
              <span class="ml-2 tmsk-blue-text">Kids White</span>
            </label>
            <label class="inline-flex items-center pb-1 ml-5">
              <input
                type="radio"
                class="form-radio"
                name="radio"
                value="sm2_adult_navy"
                v-model="selectedSku"
              />
              <span class="ml-2 tmsk-blue-text">Adult Navy</span>
            </label>
            <br />
            <label class="inline-flex items-center pb-1 ml-5">
              <input
                type="radio"
                class="form-radio"
                name="radio"
                value="sm2_adult_le"
                v-model="selectedSku"
              />
              <span class="ml-2 tmsk-blue-text"
                >Adult Black/ Denim/ Peach (Limited Edition)</span
              >
            </label>
            <br />
            <label class="inline-flex items-center pb-1 ml-5">
              <input
                type="radio"
                class="form-radio"
                name="radio"
                value="sm2_kids_le"
                v-model="selectedSku"
              />
              <span class="ml-2 tmsk-blue-text"
                >Kids Black/ Denim/ Peach (Limited Edition)</span
              >
            </label>
          </div> -->

          <div class="flex flex-wrap justify-center mt-2 text-left">
            <label
              v-for="(oneFilter, index) in skuFilters"
              :key="index"
              class="inline-flex items-center pb-1 ml-5"
              data-e2e-attr="locate-vm-sku-filters"
            >
              <input
                type="radio"
                class="form-radio"
                name="radio"
                :value="oneFilter.skuId"
                v-model="selectedSku"
              />
              <span class="ml-2 tmsk-blue-text">{{ oneFilter.displayName }}</span>
            </label>
          </div>

          <p
            v-if="valid === false"
            class="mt-4 text-sm text-center text-red-600"
          >
            Please enter a valid postal code.
          </p>
          <p
            v-if="hasSearched && locations.length === 0"
            class="mt-4 text-sm text-center text-red-600"
          >
            No results found. Please try another postal code.
          </p>
          <button
            data-e2e-attr="filter-locate-vm-skus-btn"
            class="flex items-center px-10 py-2 m-auto mt-4 text-white rounded-full tmsk-blue-bg focus:outline-none"
            @click="handleSearch"
          >
            Search
          </button>
          <div
            id="locate-vm-cards"
            class="flex flex-col items-center justify-start mt-10 space-y-4"
            v-if="locations.length > 0"
          >
            <!-- Individual cards start here -->
            <card
              v-for="(location, index) in locations"
              :key="index"
              class="w-full space-y-4"
            >
              <template #body>
                <!-- Name -->
                <p class="text-lg font-bold tmsk-blue-text">
                  {{ location.name }}
                </p>
                <p class="text-xs text-gray-500">
                  {{ Math.floor(location.distance).toFixed(0) }}m away from your
                  postal code
                </p>
                <!-- Address -->
                <div
                  class="flex flex-row items-center justify-start mt-3 space-x-4"
                >
                  <img src="@/assets/img/locate-pin-icon.png" class="w-4" />
                  <a
                    :href="'https://maps.google.com/?q=' + location.postal"
                    target="_blank"
                    ><p class="underline capitalize tmsk-blue-text">
                      {{ location.address }} S({{ location.postal }})
                    </p></a
                  >
                </div>
                <!-- Product Capacity -->
                <div
                  v-for="([product, qty], index) in Object.entries(
                    location.products
                  )"
                  :key="index"
                  class="flex flex-wrap mt-3"
                >
                  <!-- <img src="@/assets/img/locate-stock-icon.png" class="w-4" /> -->
                  <p class="w-4 mr-4 text-center">
                    <!-- {{
                      product
                        .split("_")[1]
                        .replace(/^\w/, (c) => c.toUpperCase())
                        .concat(
                          " ",
                          product
                            .split("_")[2]
                            .replace(/^\w/, (c) => c.toUpperCase())
                        )
                    }} -->
                    {{
                      skuFilters.find((filter) => filter.skuId === product)
                        .displayName
                    }}
                  </p>
                  <!-- Quantity Badge -->
                  <p
                    v-if="qty >= 0.3"
                    style="background-color: #00cd8b"
                    class="w-1/2 px-2 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    High
                  </p>
                  <p
                    v-else-if="qty >= 0.1 && qty < 0.3"
                    style="background-color: #ffb800"
                    class="w-1/2 px-6 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    Low
                  </p>
                  <p
                    v-else-if="qty < 0.1"
                    style="background-color: #d43131"
                    class="w-1/2 px-6 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    Out of Stock
                  </p>
                  <p
                    v-else-if="qty === null"
                    style="background-color: #d43131"
                    class="w-1/2 px-6 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    Out of Service
                  </p>
                  <!-- <p
                    v-if="product === 'sm3_maskFIT_s'"
                    style="background-color: #00cd8b"
                    class="w-1/2 px-2 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    High
                  </p>
                  <p
                    v-else-if="product === 'sm3_maskFIT_m'"
                    style="background-color: #ffb800"
                    class="w-1/2 px-6 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    Low
                  </p>
                  <p
                    v-else-if="product === 'sm3_maskFIT_l'"
                    style="background-color: #d43131"
                    class="w-1/2 px-6 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    Out of Stock
                  </p>
                  <p
                    v-else-if="product === 'sm3_maskFIT_xl'"
                    style="background-color: #d43131"
                    class="w-1/2 px-6 py-1 text-sm text-center text-white rounded-md sm:w-1/2 md:w-1/3"
                  >
                    Out of Service
                  </p> -->
                  <!-- <p
                    class="flex items-center my-auto ml-3 text-xs sm:ml-4 md:text-md"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      class="w-4 h-4 mr-1 check sm:mr-2"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    {{
                      ["sm2_adult_white", "sm2_kids_white"].includes(product)
                        ? "Free & Pre-Order"
                        : "Pre-Order"
                    }}
                  </p> -->
                </div>
              </template>
            </card>
          </div>
        </div>
      </div>
    </centralized>
  </full-width>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import beepAPI from '../../mixins/beepAPI'
import FullWidth from '../../components/Layout/FullWidth'
import Centralized from '../../components/Layout/Centralized'
import Tooltip from '../../components/Tooltip'
import BackButton from '../../components/BackButton'
import Card from '../../components/Card'
import moment from 'moment'
import { PREORDER_PERIOD, COLLECTION_PERIOD, CHEATSHEET_URL, COLLECTION_END_DATE } from '../../Constants'
export default {
  name: 'LocateVendingMachines',
  metaInfo () {
    return {
      title: 'Locate Vending Machines',
      // meta: [
      //   { property: 'og:title', content: 'Locate Vending Machines' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'Locate Vending Machines' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-03.jpg' }
      // ],
      link: [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  components: {
    FullWidth,
    Centralized,
    Tooltip,
    BackButton,
    Card
  },
  mixins: [beepAPI],
  props: {
    filterProps: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      input: '',
      valid: null,
      hasSearched: false,
      locations: [],
      selectedSku: this.filterProps
    }
  },
  computed: {
    ...mapState(['isPayLahTile']),
    ...mapGetters(['skuFilters', 'isFetchingFilters', 'showFetchingFiltersErrorPopup', 'isPreOrderActive'])
  },
  watch: {
    input (newValue) {
      if (newValue.length === 7) {
        this.input = this.input.slice(0, -1)
      } else {
        this.valid = null
      }
    }
  },

  // Lifecycle Hooks
  async created () {
    this.preOrderPeriod = PREORDER_PERIOD
    this.collectionEndDate = moment(COLLECTION_END_DATE).format('dddd, DD MMM, hh:mma')
    this.collectionPeriod = COLLECTION_PERIOD
    this.cheatSheetUrl = CHEATSHEET_URL

    await this.getSkuFilters()
    if (!this.isFetchingFilters && this.showFetchingFiltersErrorPopup) {
      this.createModal({
        title: 'Something went wrong',
        message: 'Failed to load locations',
        btnMessage: 'Proceed',
        callback: () => {},
        clickOutsideHide: false
      })
    }
  },
  methods: {
    ...mapActions(['getSkuFilters']),
    getSearchResults (postal, sku) {
      document.activeElement.blur()
      return new Promise((resolve, reject) => {
        const filter = sku === 'all' ? '' : '&filter=' + sku

        this.$locationAxios.get('/entity/S5881427/nearest?count=10&postal=' + postal + filter)
          .then(
            response => {
              resolve(response.data)
            },
            error => {
              reject(error)
            }
          )
      })
    },

    async handleSearch () {
      const postal = this.input
      const sku = this.selectedSku
      this.valid = this.validatePostal(postal)

      if (this.valid) {
        this.setIsLoading(true)
        this.getSearchResults(postal, sku)
          .then(
            response => {
              this.hasSearched = true
              this.locations = response
              this.setIsLoading(false)
            },
            error => {
              this.setIsLoading(false)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to search for locations.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              console.error(error)
            }
          )
      }
    },

    validatePostal (input) {
      const regex = /\d{6}/
      return regex.test(input)
    }
  }
}
</script>

<style scoped>
</style>
